
import React, { createContext, useContext, useState, useEffect } from 'react';
import { themes } from './themes';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    return localStorage.getItem('talent-talks-theme') || 'light';
  });

  useEffect(() => {
    const applyTheme = (themeName) => {
      const root = document.documentElement;
      const themeData = themes[themeName];
      
      // Apply theme name as data attribute
      root.setAttribute('data-theme', themeName);
      
      // Apply CSS variables from the .vars property
      if (themeData.vars) {
        Object.entries(themeData.vars).forEach(([key, value]) => {
          root.style.setProperty(key, value);
        });
      }
      
      // Persistence
      localStorage.setItem('talent-talks-theme', themeName);
    };

    applyTheme(currentTheme);
  }, [currentTheme]);

  const setTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
    }
  };

  const themeColors = themes[currentTheme].colors;

  return (
    <ThemeContext.Provider value={{ currentTheme, setTheme, themes, themeColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
